import { Guid } from '@web/utils';
import { PaymentMethodCode } from '../../../shared/enums';
import { jsonMember } from 'typedjson';

export class PublicPaymentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;
}
